import { useEffect, useState, useRef } from "react"
import arrowDown from '../assets/new-ui/arrow-light-down.png'
import parse  from 'html-react-parser'
export default function CustomSelection(props) {
  const { list, setCurrent, title, customArrow, innerWidth, boxWidth} = props
  const [selectedShow, setSelectedShow] = useState(null)
  const [toggle, setToggle] = useState(false)
  const ref = useRef()

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setToggle(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    if (!title) {
      setSelectedShow(list[0])
      setCurrent(list[0])
    }
    else {
      setSelectedShow(title)
      setCurrent(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  function select(index) {
    setSelectedShow(list[index])
    setCurrent(list[index])
  }
  return (
    <div className='customSelection' onClick={() => setToggle(old => !old)} ref={ref}>
      <img src={customArrow ? customArrow : arrowDown} alt='dropdown icon' className='selectionArrow' />
      <div className='selectionTitle' style={{width: innerWidth}}>{selectedShow ? parse(selectedShow) : ''}</div>

      <div className={toggle ? 'dropdownList dropdownListShow ' : 'dropdownList dropdownListHidden'} style={{width: boxWidth ? boxWidth : innerWidth}}>
        {
          list.map((item,index) => {
            return (
              <div key={index} onClick={() => select(index)}>{parse(item)}</div>
            )
          })
        }
      </div>
    </div>
  )
}